import DataBreakdownTable from './DataBreakdownTable'

export default DataBreakdownTable
